'use strict';

var checkoutInfo = {
	shippingInfoEvent: function () {
		if (!$('input[name=shippingData]').length) {
			return;
		}

		var shippingInfo = JSON.parse($('input[name=shippingData]').val());
		var obj = {
			'event': 'add_shipping_info',
			'ecommerce': shippingInfo
		};
		dataLayer.push(obj);
	},
	paymentInfoEvent: function () {
		if (!$('input[name=paymentData]').length) {
			return;
		}

		var paymentInfo = JSON.parse($('input[name=paymentData]').val());
		var obj = {
			'event': 'add_payment_info',
			'ecommerce': paymentInfo
		};
		dataLayer.push(obj);
	}
};
module.exports = checkoutInfo;
